module.exports = __webpack_public_path__ + "static/img/serverNew.29bb9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serverNew.jpg
// module id = TTlP
// module chunks = 0